module.exports = __webpack_public_path__ + "img/product1.8f7dc153.png";